var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"battleItemButtonContainer",class:("battleItemButtonContainer_" + _vm.type)},[_c('button',{staticClass:"battleItemButton"},[_vm._v("\n        "+_vm._s(_vm.word)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }